import React from 'react';
import DynamicComponent from './components/DynamicComponent';
import StaticComponent from './components/StaticComponent';
import CategoryListTileSection from './components/CategoryListTileSection';
import BannerImageCarousel from './components/BannerImageCarousel';
import VerticalImageCarousel from './components/VerticalImageCarousel';
import GenericCarousel from './components/GenericCarousel';
import HeroBanner from '../Content/MarketingSectionContainer/HeroBanner';
import CTAContainer from './components/CTAContainer';
import FAQContainerComponent from './components/FAQContainerComponent';
import DownloadButtonContainer from './components/DownloadButtonContainer';
import DraggableCarousel from './components/DraggableCarousel';
import ProductRecommendationCarousel from './components/ProductRecommendationCarousel';
import CommonUtil from '../../../utils/commonUtil';

const channel = CommonUtil.getChannel();
const isWap = channel === 'wap';

const MarketingContentSection = ({ contentSection, store, downloadPdfData }) => {
  // Helper mappers from new API -> existing component props
  const pickImg = (img) =>
    isWap
      ? img?.mobile?.src || img?.tablet?.src || img?.desktop?.src || ''
      : img?.desktop?.src || img?.tablet?.src || img?.mobile?.src || '';

  const pickImgObj = (img) => {
    return {
      mobile: img?.mobile?.src || '',
      tablet: img?.tablet?.src || img?.mobile?.src ||'',
      desktop: img?.desktop?.src || img?.mobile?.src || '',
    }
  }
  const mapCarousel = (slot) => ({
    title: slot?.title,
    sub_title: slot?.sub_title,
    description: slot?.description,
    carousel_display_template: slot?.carousel_display_template,
    carousel_settings: slot?.settings,
    direction: slot?.direction,
    background_color: slot?.background_color,
    ...(slot?.carousel_title && {carousel_title: slot?.carousel_title}),
    ...(slot?.category_id && {category_id: slot?.category_id}),
    // Adapt to HomePagecarousel/BannerImageCarousel expected structure
    carousel_cards: (slot?.carousel_items || []).map((it) => ({
      banner_image: { url: pickImg(it?.image) },
      banner_image_title: it?.title,
      banner_sub_title: it?.sub_title,
      banner_description: it?.description,
      cta: it?.cta,
      align: it?.align,
      background_color: it?.background_color,
    })),
  });

  const mapCardsGrid = (slot) => ({
    title: slot?.title,
    sub_title: slot?.sub_title,
    description: slot?.description,
    // Adapt to CategoryListTileSection expected structure
    categories: (slot?.cards || []).map((c) => ({
      category_name: c?.label,
      placeholder_image: pickImgObj(c?.image),
      cta: c?.cta,
      ...c,
    })),
  });

  // New API path
  if (Array.isArray(contentSection?.marketing_slots)) {
    return (
      <div class='marketing-content-section'>
        {contentSection.marketing_slots.map((slot, index) => {
          const type = slot?.content_type_uid;

          if (type === 'content_hero_banner') {
            return <HeroBanner key={`hero-${index}`} data={slot} state={store} />;
          }

          if (type === 'content_dynamic_component') {
            return (
              <DynamicComponent
                key={`dyn-${index}`}
                name={slot?.component_name}
                state={store}
              />
            );
          }

          if (type === 'content_carousel') {
            const component = mapCarousel(slot);
            // console.log('content_carousel', component);
            // Use HomePagecarousel to render image/title/subtitle lists responsively
            return (
              <GenericCarousel
                key={`car-${index}`}
                component={component}
                state={store}
              />
            );
          }

          if (type === 'content_draggable_carousel') {
            const component = mapCarousel(slot);
            return (
              <DraggableCarousel
                key={`car-${index}`}
                component={component}
                state={store}
              />
            );
          }

          if (type === 'content_product_recommendations') {
            const component = mapCarousel(slot);
            return (
              <ProductRecommendationCarousel
                key={`car-${index}`}
                component={component}
                state={store}
              />
            );
          }

          if (type === 'content_card_tile_layout') {
            const component = mapCardsGrid(slot);
            return (
              <CategoryListTileSection
                key={`grid-${index}`}
                component={component}
                state={store}
              />
            );
          }

          if (type === 'content_call_to_action_container') {
            return (
              <CTAContainer
                component={slot}
                state={store}
              />
            );
          }

          if(type === "content_faq_container"){
               return(
                <FAQContainerComponent 
                  id={index}
                  component={slot}
                />
               )
          }

          if(type === "content_download_pdf_container"){
            return(
              <DownloadButtonContainer 
                component={slot}
                state={store}
                downloadPdfData={downloadPdfData}
              />
            )
          }

          return <></>;
        })}
      </div>
    );
  }

  // Legacy path (kept intact)
  return (
    <div class='marketing-content-section'>
      {contentSection?.page_components?.map((component, index) => {
        const componentType = Object.keys(component)[0];

        switch (componentType) {
          case 'static_component_html':
            return (
              <StaticComponent
                key={index}
                title={component['static_component_html']?.title}
                content={component['static_component_html']?.content}
              />
            );
          case 'dynamic_component':
            return (
              <DynamicComponent
                key={index}
                name={component['dynamic_component']?.component_name}
                state={store}
              />
            );
          case 'category_list_tile_section':
            return (
              <CategoryListTileSection
                key={index}
                component={component['category_list_tile_section']}
                state={store}
              />
            );
          case 'banner_image_carousel':
            return (
              <BannerImageCarousel
                key={index}
                component={component['banner_image_carousel']}
                state={store}
              />
            );
          case 'vertical_image_carousel':
            return (
              <VerticalImageCarousel
                key={index}
                component={component['vertical_image_carousel']}
                state={store}
              />
            );
          case 'horizontal_image_carousel':
            return (
              <GenericCarousel
                key={index}
                component={component['horizontal_image_carousel']}
                state={store}
              />
            );
        }

        return <></>;
      })}
    </div>
  );
};

export default MarketingContentSection;
